// extracted by mini-css-extract-plugin
export var contrastLow = "_2h-1";
export var externalLink = "_2h-2";
export var externalLinkIcon = "_2h-3";
export var link = "_2h-0";
export var linkLabel = "_2h-4";